
























































































import { Contact } from "../../models/Contact";
import StringUtils from "../../utils/StringUtils";
import { ListParamApi } from "../../api/ListParamApi";
import { EListParamType, Option } from "../../models/Option";

export default {
    name: "CoordonneeSelector",
    props: {
        contact: Contact,
        withoutAdditionalEmails: {
            type: Boolean,
            default: false,
        },
        value: String,
        preSelectRole: Contact.ERole,
        nested: false,
    },
    data() {
        return {
            selectedEmails: [],
            additionalEmails: [],
            syndicEmails: "",
            ListParamApi: new ListParamApi(),
        };
    },
    created() {
        let self = this;
        _.each(self.contact.emails, function (coordonnee) {
            if (self.preSelectRole && coordonnee.roles) {
                self.ListParamApi.getAll({
                    type: Option.EListParamType.role_contact,
                }).then(function (roles) {
                    let selectedRole = _.find(roles, {
                        name: self.preSelectRole,
                    });
                    if (selectedRole) {
                        let role = _.find(coordonnee.roles, function (role) {
                            return role === selectedRole.id;
                        });
                        if (role) {
                            self.selectedEmails.push(coordonnee.email);
                        }
                    }
                });
            } /*else {
                if (coordonnee.roles && coordonnee.roles.length > 0) {
                    self.selectedEmails.push(coordonnee.email);
                }
            }*/
        });
    },
    methods: {
        // Contact emails
        isSelected(email): boolean {
            return _.includes(this.selectedEmails, email);
        },
        selectEmail(email): void {
            if (this.isSelected(email)) {
                _.pull(this.selectedEmails, email);
                this.$forceUpdate();
            } else {
                this.selectedEmails.push(email);
            }
            this.updateEmailList();
        },
        // Additional emails
        addAdditionalEmail(): void {
            this.additionalEmails.push({ value: "", key: _.uniqueId() });
        },
        removeAdditionalEmail(email): void {
            _.remove(this.additionalEmails, { key: email.key });
            this.$forceUpdate();
            this.updateEmailList();
        },
        // Events
        updateEmailList() {
            let emails = _.join(this.emailsValues(), ",");
            this.$emit("input", emails);
        },
        // Props
        emailsValues: function () {
            return _.concat(
                this.selectedEmails,
                _.map(this.additionalEmails, "value"),
                _.split(this.syndicEmails, ",")
            ).filter(function (email) {
                return email !== "" && StringUtils.isValidEmail(email);
            });
        },
    },
    computed: {
        emailsValuesProperty: function () {
            return this.emailsValues();
        },
    },
    watch: {
        syndicEmails: {
            immediate: true,
            handler() {
                this.updateEmailList();
            },
        },
        emailsValuesProperty: {
            immediate: true,
            deep: true,
            handler() {
                this.updateEmailList();
            },
        },
    },
};
